import React, { useState } from 'react';
import { MDBCollapse, MDBBtn } from 'mdb-react-ui-kit';
import { useParams } from 'react-router-dom';
import MortalidadInstitucional from './Indicadores/MortalidadInsitucional';
import MorbilidadInstitucional from './Indicadores/MorbilidadInstitucional';
import GrupoAyB from './Indicadores/GrupoAyB';


function Indicadores() {
  let { id } = useParams();
  console.log(id);
  const [showShow, setShowShow] = useState(false);
  const [showShow1, setShowShow1] = useState(false);
  const [showShow2, setShowShow2] = useState(false);
 
  const toggleShow = () => setShowShow(!showShow);
  const toggleShow1 = () => setShowShow1(!showShow1);
  const toggleShow2 = () => setShowShow2(!showShow2);



  return (
    <>
      <div className="test">
        <div>
          <div className="container">
            <div className="text-center">
              <div class="container-fluid">
                <div class="card shadow mb-4">
                  <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">Indicadores</h6>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive"></div>

                    <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">



                      <tr> <MDBBtn outline className="btn btn-light btn-user btn-block" onClick={toggleShow}>
                     1. Indicadores grupo AyB
                      </MDBBtn>
                        <MDBCollapse show={showShow}>
                          <GrupoAyB />
                        </MDBCollapse>
                      </tr>
                      <hr className="sidebar-divider" />  
                      <tr>
                        <MDBBtn outline className='btn btn-light btn-user btn-block' color='primary' onClick={toggleShow1}>
                        2. Indicadores grupo C Morbilidad
                        </MDBBtn>
                        <MDBCollapse show={showShow1}>
                            <MorbilidadInstitucional />
                        </MDBCollapse>
                      </tr>
                      <hr className="sidebar-divider" />  
                      <tr>
                        <MDBBtn outline className="btn btn-light btn-user btn-block" onClick={toggleShow2}>
                        3. Indicadores grupo C Mortalidad
                        </MDBBtn> 

                        <MDBCollapse show={showShow2}>
                        <MortalidadInstitucional />
                        </MDBCollapse>
                      </tr>
                     
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Indicadores;